var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"aa-home"},[_c('Banner'),_c('DoCard'),_c('PrintingCard'),_c('FreshArtSlider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }